import { routeForDocument } from '@metmuseum/routes';
import SanityImage from '@sanity-image';
import RedundantLink from 'components/accesibility/redundant-link';
import styles from './image.module.scss';
import React, { type CSSProperties } from 'react';
import { type Image } from '@metmuseum/types';

export const PublicationCardImage = ({
	coverImage,
	slug,
	_type,
	height,
	link,
	onClick,
}: props) => {
	return (
		<div
			className={styles.imageWrapper}
			style={{ '--image-height': height || '320px' } as CSSProperties}
		>
			{coverImage && (
				<SanityImage
					className={styles.image}
					image={coverImage}
					sizes="250px"
				/>
			)}
			<RedundantLink
				href={slug ? routeForDocument({ slug: slug, _type: _type }) : link}
				onClick={onClick}
			/>
		</div>
	);
};

interface IPublicationProps {
	_type: string;
	coverImage: Image;
	height?: string;
	link?: never;
	onClick?: React.MouseEventHandler<HTMLAnchorElement>;
	slug: {
		current: string;
	};
}

interface IDownloadablePDFProps {
	_type?: never;
	coverImage: Image;
	height?: string;
	link?: string;
	onClick?: React.MouseEventHandler<HTMLAnchorElement>;
	slug?: never;
}

export type props = IPublicationProps | IDownloadablePDFProps;
